"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCannabisLabTestCreateInputSchema = exports.APosCannabisLabTestSchema = exports.APosLabTestStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosLabTestStatusSchema = zod_1.z.enum(['pending', 'passed', 'failed', 'retesting']);
exports.APosCannabisLabTestSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    labTestId: id_schema_1.EntityIdSchema,
    packageId: id_schema_1.EntityIdSchema,
    batchId: id_schema_1.EntityIdSchema.optional(),
    labName: zod_1.z.string().min(1).max(200),
    labLicenseNumber: zod_1.z.string().optional(),
    sampleId: zod_1.z.string().optional(),
    testDate: zod_1.z.number(),
    resultsDate: zod_1.z.number().optional(),
    status: exports.APosLabTestStatusSchema.default('pending'),
    potencyResults: zod_1.z.object({
        thcPercent: zod_1.z.number().min(0).max(100).optional(),
        cbdPercent: zod_1.z.number().min(0).max(100).optional(),
        totalCannabinoids: zod_1.z.number().min(0).max(100).optional(),
    }).optional(),
    contaminantResults: zod_1.z.object({
        pesticides: zod_1.z.enum(['pass', 'fail']).optional(),
        heavyMetals: zod_1.z.enum(['pass', 'fail']).optional(),
        microbials: zod_1.z.enum(['pass', 'fail']).optional(),
        residualSolvents: zod_1.z.enum(['pass', 'fail']).optional(),
        mycotoxins: zod_1.z.enum(['pass', 'fail']).optional(),
    }).optional(),
    terpeneProfile: zod_1.z.record(zod_1.z.string(), zod_1.z.number()).optional(),
    certificateUrl: zod_1.z.string().url().optional(),
    certificateKey: zod_1.z.string().optional(),
    notes: zod_1.z.string().max(2000).optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosCannabisLabTestCreateInputSchema = zod_1.z.object({
    packageId: id_schema_1.EntityIdSchema,
    batchId: id_schema_1.EntityIdSchema.optional(),
    labName: zod_1.z.string().min(1).max(200),
    labLicenseNumber: zod_1.z.string().optional(),
    sampleId: zod_1.z.string().optional(),
    testDate: zod_1.z.number(),
    notes: zod_1.z.string().max(2000).optional(),
});
//# sourceMappingURL=cannabis-lab-test.schema.js.map